import Molde from "./MoldeTourTradicionalTrek";
import CardLugar from "../common/card/CardLugar";
import CardRecomienda from "../common/card/CardRecomienda";
import CardCaracteristica from "../common/card/CardCaracteristica";
import React from 'react';


export default function Waqrapukara() {
  return (
    <>
      <Molde
        image={"/images/portada-waqrapukara.png"}
        title={"WAQRAPUKARA"}
        subtitle={"(FULL DAY)"}
        description={
          "Waqrapukara es un complejo arqueológico inca ubicado en Perú, específicamente en el distrito de Acos, provincia de Acomayo, departamento de Cusco. Su nombre, que significa fortaleza de cuerno en quechua, hace referencia a la peculiar forma de la montaña en la que fue construida, que parece tener dos cuernos en su cúspide. Waqrapukara es un sitio poco explorado y se considera una de las atracciones más nuevas del Cusco. Waqrapukara se encuentra a 4300 metros sobre el nivel del mar, en la cima de una quebrada, ofreciendo vistas panorámicas del paisaje. El tour a Waqrapukara suele durar un día, aunque también existen opciones de tours de dos días que combinan Waqrapukara con la Montaña de Colores o con otras atracciones. Los tours de un día generalmente incluyen transporte, guía, desayuno y almuerzo. El tour de un día a Waqrapukara suele durar alrededor de 14 horas, incluyendo 7 horas de viaje en bus y 6 horas de caminata. Estos tours incluyen recogidas en el hotel, visitas a la Laguna de Pomacanchis y el Templo de Sangarara, además de la visita a Waqrapukara. Si planeas hacer el tour de un día, es importante aclimatarse a la altura en Cusco antes del tour, ya que Waqrapukara se encuentra a una altitud de 4,300 metros sobre el nivel del mar. También se recomienda estar en buena condición física, ya que la caminata puede ser de moderada dificultad."
        }
        linkForm={"/reservar/citytour-dia"}
        tipoprecio={"Precio por persona"}
        monto={"US$ 40.00"}
        moneda={"DOLARES"}
        mapa={
          <>
            <div>
              <h1 className="text-primary-800 font-bold">UBICACIÓN</h1>
            </div>
            <img className="rounded-lg border-primary-800 border-2" src={`${process.env.PUBLIC_URL}/images/mapa_waqrapukara.png`} alt="" />
          </>
        }
        galeria={
            <>
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/waqra_1.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/waqra_2.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/waqra_3.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/waqra_4.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/waqra_5.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/waqra_6.png`} alt="" />
            </>
          }
        incluye={
          <>
            <li>Transporte turistico</li>
            <li>Guia profesional</li>
            <li>Asistencia permanente</li>
            <li>Desayuno buffet</li>
            <li>Almuerzo buffet</li>
          </>
        }
        noIncluye={
          <>
            <li>Pago de ingreso</li>
            <li>Alquiler de caballo</li>
            <li>Gastos extra</li>
          </>
        }
        recomendaciones={
          <>
            <li>Bloqueador solar.</li>
            <li>Poncho en caso de lluvia.</li>
            <li>Gorra, sombrero, guantes, lentes de sol.</li>
            <li>Botella con agua.</li>
            <li>Cortavientos, pantalón de trekking.</li>
            <li>Zapatillas ideales para trekking.</li>
            <li>Snacks, cámara fotográfica, documentos, dinero extra.</li>
          </>
        }
        caracteristica={
          <>
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/level.svg`}
              title={"Dificultad"}
              desc={"Dificil"}
            />
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/compartido.svg`}
              title={"Tipo Servicio"}
              desc={"Compartido"}
            />
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/duracion.svg`}
              title={"Duración"}
              desc={"Full day"}
            />
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/cultural.svg`}
              title={"Tipo de Tour"}
              desc={"Trek"}
            />
          </>
        }
        lugarvisita={
          <>
            <CardLugar
              icon={"/icons/street-view-solid.svg"}
              title={"Cusipata"}
            />
            <CardLugar
              icon={"/icons/street-view-solid.svg"}
              title={"Vinicunca"}
            />
            
          </>
        }
        TourRecomienda={
                  <>
                    <CardRecomienda
                      img={"/images/montania_colores.png"}
                      title={"MONTAÑA 7 COLORES"}
                      puntuacion={"4.5"}
                      link={'/tour-tradicional/montania-colores'}
                    />
                    <CardRecomienda
                      img={"/images/valle-vip-5.png"}
                      title={"VALLE VIP"}
                      puntuacion={"5"}
                      link={'/tour-tradicional/valle-vip'}
                    />
                    <CardRecomienda
                      img={"/images/cris-1.png"}
                      title={"CITY TOUR"}
                      puntuacion={"5"}
                      link={'/tour-tradicional/citytour'}
                    />
                    <CardRecomienda
                      img={"/images/maras-moray-4.png"}
                      title={"MARAS-MORAY"}
                      puntuacion={"4.5"}
                      link={'/tour-tradicional/maras-moray'}
                    />
                  </>
                }
      />
    </>
  );
}
